<al-auth-flow-modal></al-auth-flow-modal>
<al-freshdesk-help-modal #helpModal [isAdmin]="isAdmin"></al-freshdesk-help-modal>

<div class="buttons-row">
    <button *ngIf="freshdeskArticleIds.length" class="btn btn-primary btn-sm test-button" (click)="openIssueHelp()"><i class="far fa-book"></i>Help</button>

    <button [disabled]="disabled || (disabledLoginBtnSubject | async)" [hidden]="!appParams.oAuth" class="btn btn-primary btn-sm test-button" (click)="authorizebtn()"><i class="far fa-user"></i>Auth</button>

    <button [disabled]="disabled || (disabledLoginBtnSubject | async)" class="btn btn-primary btn-sm test-button" (click)="testbtn()"><i class="far fa-sign-in"></i>Test</button>

    <ng-container *ngIf="loginValiditySubject | async as validity">
        <span class="validated">
            <ng-container [ngSwitch]="validity">
                <!-- the same view can be shown in more than one case -->
                <ng-container *ngSwitchCase="ApplicationLoginStatus.undefined"></ng-container>
                <ng-container *ngSwitchCase="ApplicationLoginStatus.detailsinvalid">Login details invalid</ng-container>
                <ng-container *ngSwitchCase="ApplicationLoginStatus.invalid">Unable to authenticate</ng-container>
                <ng-container *ngSwitchCase="ApplicationLoginStatus.valid">Login valid</ng-container>
                <ng-container *ngSwitchCase="ApplicationLoginStatus.pending">Checking</ng-container>
                <!--default case when there are no matches -->
            </ng-container>

            <i class="far" [ngClass]="{
        'text-danger': validity === ApplicationLoginStatus.undefined,
        'fa-exclamation-circle text-danger': [ApplicationLoginStatus.invalid, ApplicationLoginStatus.detailsinvalid].includes(validity),
        'fa-check-circle text-success': validity === ApplicationLoginStatus.valid,
        'fa-spinner fa-pulse': validity === ApplicationLoginStatus.pending
    }"></i>
        </span>
    </ng-container>
</div>
